import OrganizationPersonAdd from '@/screens/OrganizationPersonAdd';

export default function PrivateOrganizationPersonAddIndexRoute() {
  return <OrganizationPersonAdd />;
}
